const layout = () => import("../../gerente/layout.vue");
const gerenteCadastro = () => import("./gerenteCadastro.vue");

const gerenteCadastroRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "gerenteCadastro",
      component: gerenteCadastro,
    },
  ],
};

export default gerenteCadastroRoutes;